import { render, staticRenderFns } from "./FillBlanks.vue?vue&type=template&id=36d85792&scoped=true"
import script from "./FillBlanks.vue?vue&type=script&lang=ts"
export * from "./FillBlanks.vue?vue&type=script&lang=ts"
import style0 from "./FillBlanks.vue?vue&type=style&index=0&id=36d85792&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d85792",
  null
  
)

export default component.exports